var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "holiday-alert-wrap" },
    [
      _c(
        "el-alert",
        {
          staticClass: "holiday-alert",
          attrs: { type: "warning", "show-icon": "" }
        },
        [
          _c(
            "p",
            {
              staticClass: "holiday-alert-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                "\n\t\t\t1024热门产品套餐直降，充3万得5万，充5万得10万，优惠折上折！"
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.baseUrl + "/activities/1024/recharge?ch=1024console"
                  }
                },
                [_vm._v("活动详情>>")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-377e8e87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377e8e87","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/HolidayAlert/Main.vue
// module id = 757
// module chunks = 40